import React, { useEffect, useState } from "react";
import { Route, Switch, BrowserRouter, Link } from "react-router-dom";
import Login from "./Components/Login";
import Dashboard from "./Components/Dashboard";
import RangeForcasting from './Fmu/RangeForcasting';
import Fcmt from './Fmu/Fcmt';
import { Button, Result, Spin } from "antd";
import { handleAuthCallback, redirectToLogin, logout } from "./auth/AuthService";

const Routes = (props) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("ecotrip_user");
    if (storedUser) {
      setUser(JSON.parse(storedUser).idTokenClaims);
    } else {
      handleAuthCallback().then((claims) => {
        if (claims) setUser(claims);
      });
    }
  }, []);

  const loaderStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 100001,
    color: '#fff'
  };

  if (!user) {
    return (
      <div className='backdrop'>
        <div className='loader'>
          {/* <Spin size="large" /> */}
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Fcmt} />
        {/* Add other routes here */}
        <Route
          render={() => {
            return (
              <Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
                extra={
                  <Button type="primary">
                    <Link to="/">Back Home</Link>
                  </Button>
                }
              />
            );
          }}
        />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
